import styled from 'styled-components';

export const ProjectsContainer = styled.div`
  min-height: 100vh;
  padding: 2rem;
  background: var(--bg-main);
  color: var(--text-main);
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  
  h1 {
    font-size: 2.5rem;
    font-weight: 700;
    margin: 0;
  }
`;

export const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
`;

export const ProjectCard = styled.div`
  background: var(--bg-card);
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--border-color);
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
  position: relative;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  }

  .action-button {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    z-index: 12;
    width: 1rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: rgba(0,0,0,0.6);
    border: 1px solid rgba(255,255,255,0.12);
    transition: transform 0.12s ease, background 0.12s ease;

    .pi {
      color: #fff;
      font-size: 1.1rem;
    }
  }
`;

export const PublishedBadge = styled.div`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background: ${props => props.published ? 'rgba(34, 197, 94, 0.9)' : 'rgba(107, 114, 128, 0.9)'};
  color: white;
  padding: 0.35rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  z-index: 10;
  text-transform: uppercase;
  backdrop-filter: blur(8px);
`;

export const ProjectCover = styled.div`
  width: 100%;
  height: 180px;
  background: ${props => props.image ? `url(${props.image})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'};
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  font-size: 3rem;
`;

export const ProjectContent = styled.div`
  padding: 1.5rem;

  h3 {
    margin: 0 0 0.75rem 0;
    font-size: 1.5rem;
    font-weight: 700;
  }

  p {
    color: var(--text-secondary);
    margin: 0 0 1rem 0;
    font-size: 1rem;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const ProjectMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 1rem 0;
`;

export const ProjectActions = styled.div`
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  padding-top: 1rem;
  border-top: 1px solid var(--border-color);

  .p-button {
    width: 2rem;
    height: 2rem;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  color: var(--text-secondary);

  i {
    font-size: 4rem;
    margin-bottom: 1rem;
    display: block;
  }

  h3 {
    margin: 1rem 0 0.5rem 0;
    color: var(--text-main);
  }

  p {
    margin: 0 0 2rem 0;
  }
`;
